
// main.ts
import { createApp, reactive } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
//引入路由配置
import router from './router'
// http请求工具
import axios from 'axios'
import apiConfig from '../config/config.js'
axios.defaults.baseURL = apiConfig.baseURL;

//import axios from 'axios'
export const request = (config) => {
  return axios(config);
};
axios.interceptors.request.use(
  config => {
    // 判断是否存在token，如果存在的话，则每个http header都加上token
    config.headers.Authorization = localStorage.getItem('Authorization');

    return config;
  },
  err => {
    return Promise.reject(err);
  });

const app = createApp(App)

// 全局参数
const globalVars = reactive({
  screenWidth: 0,
  var2: 'value2'
})

app.provide('globalVars', globalVars)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// app.use(axios)
app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
})
app.mount('#app')

const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}
 
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}
 